import { TravelMap } from '@/components/gamification/TravelMap';
import { TripErrorBoundary } from '@/utils/errorBoundary';

export default function TravelMapRoute() {
  return (
    <TripErrorBoundary name="GamificationTravelMap">
      <TravelMap />
    </TripErrorBoundary>
  );
}
